<template>
  <section role="main" class="content-body" style="min-height:700px;">
    <header class="page-header">
      <h2>新增工讀生</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>工讀生清單</span></li>
          <li><span>新增工讀生</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-0" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-md-2 control-label">學　　號：</label>
                <div class="col-md-4"><input type="text" name="account" placeholder="請輸入學號" v-model="stuId"> <a href="#" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;" @click.prevent="studentSearch">查詢</a></div>
                <label class="col-md-2 control-label">姓　　名：</label>
                <div class="col-md-4">{{info.name}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">性　　別：</label>
                <div class="col-md-4">{{info.sex}}</div>
                <label class="col-md-2 control-label">聯絡電話：</label>
                <div class="col-md-4">{{info.phone}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">身分證字號：</label>
                <div class="col-md-4">{{info.idno}}</div>
                <label class="col-md-2 control-label">出生年月日：</label>
                <div class="col-md-4">{{info.birthday}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">應聘者系所：</label>
                <div class="col-md-4">{{info.deptName}}</div>
                <label class="col-md-2 control-label">年　　級：</label>
                <div class="col-md-4">{{info.grade}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">緊急聯絡人：</label>
                <div class="col-md-4">{{info.parentName}}</div>
                <label class="col-md-2 control-label">關　　係：</label>
                <div class="col-md-4">{{info.kinship}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">聯絡電話：</label>
                <div class="col-md-4">{{info.parentPhone}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">聘僱期間<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-9">
                  開始時間 <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.startDate" :disabled-dates="beginState.disabledDates" placeholder="開始時間" :style="{width:'auto', display:'inline-block'}" />
                ～　結束時間 <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.endDate" :disabled-dates="beginState.disabledDates" placeholder="結束時間" :style="{width:'auto', display:'inline-block'}" />
                </div>
               </div>
              <div class="form-group">
                <label class="col-md-2 control-label">工作內容<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-10"><textarea style="width:100%" rows="4" v-model="form.workContent">文字欄位即可</textarea></div>
              </div>
              <br>
              <table width="100%">
                <tr>
                  <td align="right"><a href="#" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;" @click.prevent="formClear">重　　填</a>　</td>
                  <td align="left">　<a href="#" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;" @click.prevent="formSubmit">送　　出</a></td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      stuId: "",
      info: {},
      form: {
        workstudyType: "",
        studentId: "",
        startDate: "",
        endDate: "",
        workContent: ""
      },
      beginState:{
				disabledDates:{
					to: null
				}
      },
    }
  },
  mounted() {
    this.beginState.disabledDates.to = this.nowDate();
    this.form.workstudyType = this.$route.params.type;
  },
  methods: {
    studentSearch() {
      this.stuId = this.stuId.trim();
      if (this.stuId == "") {
        alert("請輸入學號資料");
        return false;
      }
      this.$http.get("/api/workstudy/student-info-by-stuid", {params: {stuId: this.stuId}}).then(a => {
        this.info = a.body;
        this.form.studentId = this.stuId;
      }).catch(a => {
        if (a.status == 400) {
          alert("查無此學號");
        }
      });
    },
    formClear() {
      this.stuId = "";
      this.info = {};
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.workContent = "";
    },
    formSubmit() {
      if (this.form.studentId == "") {
        alert("請先取得學生資料");
        return false;
      }
      if (this.checkForm() == false) return;
      this.$http.post("/api/workstudy/create-workstudy", this.form).then(a => {
        if (a.body.status) {
          alert("新增成功");
          this.$router.push("/workstudy");
        } else {
          alert(a.body.msg);
        }
      });
    },
    checkForm() {
      let msg = "";
      if (this.form.startDate == "") msg += "『聘僱開始時間』、";
      if (this.form.endDate == "") msg += "『聘僱結束時間』、";
      if (this.form.workContent == "") msg += "『工作內容』、";
      if (msg != "") {
        alert(msg.substr(0, msg.length - 1) + " 尚未填寫");
        return false;
      }
      let sd = new Date(this.form.startDate),
        ed = new Date(this.form.endDate);
      if (sd > ed) {
        alert("『聘僱開始時間』請晚於『聘僱結束時間』")
        return false;
      }
      //判斷聘用期間
      var startMonth = sd.getMonth() + 1;
      console.log(startMonth);
      if(startMonth >= 2 && startMonth <= 7) {
        if(ed >= new Date(sd.getFullYear(), 7, 1)) {
          alert("聘僱期間錯誤，上學期需介於 8/1 到 隔年1/31，下學期需介於 2/1 ~ 7/31");
          return false;
        }
      }else {
        if(ed >= new Date(startMonth == 1 ? sd.getFullYear() : sd.getFullYear()+1, 1, 1)) {
          alert("聘僱期間錯誤，上學期需介於 8/1 到 隔年1/31，下學期需介於 2/1 ~ 7/31");
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<style>
</style>
